<template lang="pug">
bundle(v-if="dependency.passes")
  Expand
    div(v-if="dependency.passes")
      div
        template(
          v-for="(sub, i) in field.fields",
          :key="sub.id || sub.type + '-' + i")
          slot(name="default", :is="sub.type.toLowerCase()", :sub="sub")
</template>

<script>
import { useStore } from "vuex";
import { reactive, computed } from "vue";

import Expand from "../../transitions/Expand.vue";

export default {
  name: "Dependency",
  props: {
    field: Object
  },
  components: {
    Expand,
  },
  setup(p, context) {
    const store = useStore();

    const dependency = reactive({
      passes: computed(() => {
        const test = p.field.dependency[1];
        const groupID = p.field.groupID;
        const fields = p.field.fields;
        let value = store.getters.model[p.field.dependency[0]];
        let passesTest = false;
        
        if (groupID) {
          value = store.getters.model[`${groupID}-${p.field.dependency[0]}`]
        }

        if (Array.isArray(test)) {
          if (test.includes(null) && !value) passesTest = true;
          if (Array.isArray(value)) {
            passesTest = test.some(t => value.includes(t))
          }
          else passesTest = test.includes(value);
        }
        else {
          if (test === null && !value) passesTest = true;
          else if (Array.isArray(value)) passesTest = value.includes(test);
          else passesTest = value === test;
        }

        if (!passesTest) {
          fields.forEach((field) => store.commit("deleteModelEntry", field.id));
        }

        return passesTest;
      }),
    });
    
    return { dependency };
  }
};
</script>

<style lang="scss" scoped></style>
